// tslib contains all the helper methods that are needed when converting TypeScript to ES5 JavaScript.
// Load the library and inject it into the Worker so we can use TypeScript features in the Worker.
// (The worker only loads what we give it... not the entire bundle)
const tslib = require('tslib');

// Copied from Microsoft tslib.
// We can't simply convert __assign to a string because it will be a native method in Chrome/Firefox
/* tslint:disable */
const __assignCode = `
    var __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
`;
/* tslint:enable */

//
// Note: Everything was working fine and then __extends() (renamed during minification) started failing suddenly.
//       The error was that g was undefined. I examined tslib and determined that the "extendStatics" private
//       member was being renamed to g. Since it is private, it won't be included in tslibCode. So we
//       manually insert it here.
//
//       **WARNING** the fact that it got renamed to g (as opposed to any other letter) is not necessarily stable!!
//
// Note: I switched out "||" for "? function(a,b) { if (a && b) Object.setPrototypeOf(a, b); return a; } :" because
//       I found in Release build that the second parameter was undefined... and Chrome's behaviour didn't match what
//       MDN said should happen for undefined (namely, that nothing would happen). Instead, Chrome was throwing an
//       error. But also, I can't explain why the second parameter was undefined... by all accounts it should have
//       been a valid object being passed in.
//       MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
//
/* tslint:disable */
const extendStaticsFunctionName = 'r'; // Previously 'g'
const tslib_extendsStatics = `
    var ${extendStaticsFunctionName} = Object.setPrototypeOf ? function(a,b) { if (a && b) Object.setPrototypeOf(a, b); return a; } :
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
`;
/* tslint:enable */


// Insert the function name into the anonymous function declaration
const formatCode = (name: string, code: string): string => {
    return code.replace(/^\s*function\s?\(/, `function ${name}(`);
};

export const collectCode = (id: string, fn: Function, otherFns: Function[] = []): string => {
    // Convert all the tslib functions into source code to inject into the Worker
    const tslibCode = Object.keys(tslib)
        .filter(key => typeof tslib[key] === 'function')
        .map(key => ({
            name: key,
            code: tslib[key].toString(),
        }))
        .filter(({ code }) => code.indexOf('native code') < 0) // Remove functions we can't get source code for
        .reduce((result, { name, code }) => `${result};\r\n${formatCode(name, code)}`, '')
    ;

    // Convert dependency functions into source code to pass in as parameters to the main worker function.
    // This looks awkward here but allows us to separate the Worker code into smaller modules that can
    // be tested indepedently, etc. without having to eject from CRA and create a separate code bundle in Webpack.
    const params = [ JSON.stringify(id), ...otherFns.map(fn => fn.toString()) ];

    const allCode = [
        __assignCode,
        tslib_extendsStatics,
        tslibCode,
        `(${fn.toString()})(${params.join(',')})`,
    ].join('');

    return allCode;
};

export const createWorker = (code: string): Worker => {
    if (!window['Worker']) { // tslint:disable-line
        throw new Error('Worker API is not supported');
    }

    const blob = new Blob([ code ], { type: 'application/javascript' });
    const url = URL.createObjectURL(blob);
    const worker = new Worker(url);
    setTimeout(() => URL.revokeObjectURL(url), 5000);
    return worker;
};



// WEBPACK FOOTER //
// ./src/workers/util/createWorker.ts